import { render, staticRenderFns } from "./WrapperMngtReg.vue?vue&type=template&id=1b211be1"
import script from "./WrapperMngtReg.vue?vue&type=script&lang=js"
export * from "./WrapperMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports